import { render, staticRenderFns } from "./PostCardSkeleton.vue?vue&type=template&id=1fb35cb9&scoped=true"
import script from "./PostCardSkeleton.vue?vue&type=script&lang=js"
export * from "./PostCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PostCardSkeleton.vue?vue&type=style&index=0&id=1fb35cb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb35cb9",
  null
  
)

export default component.exports